import React, { useState, useEffect } from 'react';
import authService from '../services/authService';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if already authenticated
    if (authService.isAuthenticated) {
      onLoginSuccess();
    }
  }, [onLoginSuccess]);

  const handleLogin = async () => {
    setIsLoading(true);
    setError('');

    try {
      await authService.login();
    } catch (error) {
      console.error('Login failed:', error);
      setError('Login failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/favicon.ico" alt="Knipper Logo" className="logo-icon" />
            <h1>CareTria AI Hub</h1>
          </div>
          <p>Secure Access Required</p>
        </div>

        <div className="login-content">
          <div className="login-description">
            <p>Please sign in with your Microsoft account to access the AI Hub dashboard.</p>
          </div>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={isLoading}
            className="login-button"
          >
            {isLoading ? (
              <>
                <div className="login-spinner"></div>
                Signing in...
              </>
            ) : (
              <>
                <span className="microsoft-icon">📧</span>
                Sign in with Microsoft
              </>
            )}
          </button>
        </div>

        <div className="login-footer">
          <p>© 2026 CareTria - All Rights Reserved</p>
        </div>
      </div>
    </div>
  );
};

export default Login;